import { Switch } from '@thanx/uikit/switch'
import { ContentBlockTypes } from 'api/landingPageTheme'
import Badges from 'components/Badges'
import React from 'react'
import { getBadgeContent } from './helper'

type Props = {
  type: ContentBlockTypes
}

const ContentBadges = ({ type }: Props) => {
  const { badges, badgeDescriptions } = getBadgeContent(type)

  return (
    <Switch condition={badges.length > 0}>
      <Badges
        className="mt-m mb-xl"
        values={badges}
        badgeDescriptions={badgeDescriptions}
      />
    </Switch>
  )
}

export default ContentBadges
